import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { glassInner } from "../kota/ui";
import { deruPesawat, rampVolume } from "../../lib/suaraPesawat";

const KUNCI = "jawsel_musik_bisu";
const SRC = "/audio/beranda.mp3";   // lagu milik user (public/audio) — dimuat lazy, tidak memperlambat beranda
const VOL = 0.55, VOL_REDUP = 0.16;

// Musik latar beranda: mulai di sentuhan pertama pengunjung (aturan autoplay browser), berulang, berhenti saat keluar beranda.
// Hanya satu tombol speaker untuk bisukan/nyalakan, ditanam di ujung kanan kartu SambutanBeranda; pilihan bisukan diingat di perangkat.
// Saat pesawat melintas (event "jawsel:pesawat" dari lib/pulau/pesawat.js): lagu diredupkan + deru jet disintesis Web Audio, lalu kembali normal.
export function MusikBeranda() {
  const [bisu, setBisu] = useState(() => localStorage.getItem(KUNCI) === "1");
  const [main, setMain] = useState(false);
  const audioRef = useRef(null);
  const deruRef = useRef(null);      // fungsi penghenti deru jet yang sedang berbunyi

  useEffect(() => {
    const a = new Audio(); a.preload = "none"; a.loop = true; a.volume = VOL; a.src = SRC; audioRef.current = a;
    a.addEventListener("playing", () => setMain(true)); a.addEventListener("pause", () => setMain(false));
    let siap = false;
    const mulai = () => { siap = true; if (localStorage.getItem(KUNCI) !== "1") a.play().catch(() => {}); lepas(); };
    const lepas = () => { window.removeEventListener("pointerdown", mulai); window.removeEventListener("keydown", mulai); };
    const pesawat = e => {
      if (!siap || localStorage.getItem(KUNCI) === "1") return;          // belum ada gestur / dibisukan → diam
      if (e.detail.terbang) { rampVolume(a, VOL_REDUP, 700); deruRef.current = deruPesawat(e.detail.durasi, 0.45); }
      else { rampVolume(a, VOL, 1200); if (deruRef.current) { deruRef.current(); deruRef.current = null; } }
    };
    window.addEventListener("pointerdown", mulai); window.addEventListener("keydown", mulai); window.addEventListener("jawsel:pesawat", pesawat);
    return () => { lepas(); window.removeEventListener("jawsel:pesawat", pesawat); if (deruRef.current) deruRef.current(); a.pause(); a.src = ""; };
  }, []);

  function toggle(e) {
    e.stopPropagation();
    const a = audioRef.current, b = !bisu;
    setBisu(b); localStorage.setItem(KUNCI, b ? "1" : "0");
    if (b) { a.pause(); if (deruRef.current) { deruRef.current(); deruRef.current = null; } } else { a.volume = VOL; a.play().catch(() => {}); }
  }

  return (
    <button data-testid="musik-toggle" onClick={toggle} onPointerDown={e => e.stopPropagation()} aria-label={bisu ? "Nyalakan musik" : "Bisukan musik"} title={bisu ? "Nyalakan musik" : "Bisukan musik"}
      style={{ ...glassInner(true), position: "relative", flex: "none", width: 36, height: 36, padding: 0, display: "grid", placeItems: "center", cursor: "pointer", borderRadius: 99, alignSelf: "center" }}>
      {bisu || !main ? <VolumeX size={15} style={{ opacity: bisu ? 1 : .55 }} /> : <Volume2 size={15} />}
      {main && !bisu && <span data-testid="musik-indikator" style={{ position: "absolute", right: 4, top: 4, width: 6, height: 6, borderRadius: 99, background: "#22c55e", boxShadow: "0 0 0 2px var(--g-bg-strong)", animation: "sambut-denyut 1.6s ease-in-out infinite" }} />}
    </button>
  );
}
